import * as React from "react";
import { CollapsableCard } from "../../../../../../../components/general/collapsable_card";
import { Box, Typography } from "@mui/material";

export default function GeneralValidationErrorCard({ validationErrors, startCollapsed = false, ...props }) {
  validationErrors = validationErrors === undefined || !validationErrors ? [] : validationErrors;

  function GeneralValidationLine({ validationError }) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 0.5,
          mt: "5px",
        }}
      >
        <Typography variant="body2" sx={{ lineHeight: 1.5 }}>
          •
        </Typography>
        <Typography variant="body2">{validationError}</Typography>
      </Box>
    );
  }

  return (
    <CollapsableCard
      startCollapsed={startCollapsed || (validationErrors && validationErrors.length === 0)}
      title={`General validation errors (${validationErrors ? validationErrors.length : ""})`}
      width={"100%"}
      elevation={0}
      sx={props.sx}
    >
      {[...Array(validationErrors.length)].map((_, idx) => (
        <GeneralValidationLine validationError={validationErrors[idx]} key={idx} />
      ))}
    </CollapsableCard>
  );
}
